import { useContext } from "react";

import { ModulesContext } from "../contexts/dashboard/ModulesContext";

const useModules = () => useContext(ModulesContext);

export default useModules;
